module.exports = __webpack_public_path__ + "img/avatar5.acb79e78.png";